<template>
  <div>
    <div class="search">
      <div class="left flex1">
        <el-form label-width="82px" :mode="queryControl" label-suffix=":">
          <div class="form-box">
            <el-form-item label="年份" class="formItem">
              <el-date-picker v-model="queryControl.year" :editable="false" :clearable="false" value-format="yyyy" placeholder="请选择年份" type="year" @change="query" />
            </el-form-item>
            <el-form-item class="formItem" label="发起类型" prop="type">
              <el-select v-model="queryControl.type" placeholder="请选择" @change="query">
                <el-option label="全部" :value="''" />
                <el-option label="平台主动发起" :value="1" />
                <el-option label="客户主动发起" :value="2" />
              </el-select>
            </el-form-item>
            <template v-if="showMoreSearch">
              <el-form-item class="formItem" label="发起时间">
                <el-date-picker
                  v-model="queryControl.query_date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  :clearable="true"
                  end-placeholder="结束日期"
                  :editable="false"
                  :value-format="'yyyy-MM-dd'"
                  unlink-panels
                  :picker-options="pickerOptions"
                  @change="query"
                />
              </el-form-item>
              <el-form-item class="formItem" label="作废类型" prop="type">
                <el-select v-model="queryControl.refuse_type" placeholder="请选择" @change="query()">
                  <el-option label="全部" :value="''" />
                  <el-option label="平台撤销" :value="1" />
                  <el-option label="客户撤销" :value="2" />
                  <el-option label="平台拒绝" :value="3" />
                  <el-option label="客户拒绝" :value="4" />
                </el-select>
              </el-form-item>
            </template>
            <div class="formItem operate">
              <div>
                <el-button type="primary" @click="query">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
              </div>
              <div class="more ml10 pointer" @click="showMoreSearch = !showMoreSearch">
                <i :class="showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                <span class="ml5">{{ showMoreSearch ? '收起' : '展开' }}</span>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 月份 -->
      <template
        slot="month"
        slot-scope="{ row }"
      >
        <span>{{ row.month }}</span>
      </template>
      <!-- 消耗金额 -->
      <template
        slot="work_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.work_price) }}
      </template>
       <!-- 支付宝金额 -->
      <template
        slot="zfb_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.zfb_price) }}
      </template>
       <!-- 微信金额 -->
      <template
        slot="wx_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.wx_price) }}
      </template>
      <!-- 服务费率 -->
      <template
        slot="rate"
        slot-scope="{ row }"
      >
        {{ row.rate }}%
      </template>
      <!-- 服务费 -->
      <template
        slot="service_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.service_price) }}
      </template>
      <!-- 对账金额 -->
      <template
        slot="rcon_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.rcon_price) }}
      </template>
      <!-- 对账周期 -->
      <template
        slot="start_day"
        slot-scope="{ row }"
      >
        {{ row.start_day }} ~ {{ row.end_day }}
      </template>
      <!-- 发起时间 -->
      <template
        slot="send_time"
        slot-scope="{ row }"
      >
        {{ row.send_time }}
      </template>
      <!-- 发起类型 -->
      <template
        slot="type"
        slot-scope="{ row }"
      >
        {{ row.type == 1 ? '平台发起' : '客户发起' }}
      </template>
      <!-- 作废类型 -->
      <template
        slot="refuse_type"
        slot-scope="{ row }"
      >
        <span v-if="row.refuse_type == 1">平台撤销</span>
        <span v-if="row.refuse_type == 2">客户撤销</span>
        <span v-if="row.refuse_type == 3">客户拒绝</span>
        <span v-if="row.refuse_type == 4">用工拒绝</span>
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <span>{{ row.refuse ? row.refuse : '-' }}</span>
      </template>
      <!-- 操作 -->
      <template
        slot="action-header"
      >
        <span class="mr5">作废理由</span>
      </template>
    </zf-table>
    <!-- <noData v-else /> -->
  </div>
</template>

<script>
import column from '../columns/accountInvalid'
// import noData from '@/components/noData'
import dayJs from 'dayjs'
import ZfTable from '@/components/ZfTable/CoreTable'
import { tovoidInvoice } from '@/api/invoice'
export default {
  name: 'AccountInvalid',
  components: {
    ZfTable
  },
  data() {
    return {
      column,
      queryControl: {
        year: dayJs().format('YYYY'),
        type: '',
        query_date: [],
        refuse_type: ''
      },
      expireTimeOption: {
        disabledDate(time) {
          // 获取当前月份
          const currentdate = dayJs().format('YYYYMM')
          const timedate = dayJs(time).format('YYYYMM')
          return currentdate <= timedate
        }
      },
      tableData: [],
      pageControl: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      total: '',
      showMoreSearch: true
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    resetForm() {
      this.queryControl = {
        year: dayJs().format('YYYY'),
        type: '',
        query_date: [],
        refuse_type: ''
      }
      this.query()
    },
    async query() {
      const data = await tovoidInvoice({
        year: this.queryControl.year,
        send_time_start: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[0] : '',
        send_time_end: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[1] : '',
        refuse_type: this.queryControl.refuse_type,
        type: this.queryControl.type
      })
      if (JSON.stringify(data) !== '{}') {
        this.tableData = data.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

